import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable, of } from 'rxjs';

import { InvitationStatusType } from '@vi-iot/client';

import { GatewayInvitationsState, SearchType } from '@store';

import { GTMService } from '../../../../../shared/services';
import { GatewayInvitationsService } from '../../gateway-invitations.service';

@Component({
  selector: 'app-invitation-list',
  templateUrl: './invitation-list.component.html',
  styleUrls: ['./invitation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationListComponent implements OnInit, OnDestroy {
  @ViewChild('viewport') viewport: ElementRef;
  @Input() installationId: number;
  @Input() customerNumber: string;

  invitations$: Observable<GatewayInvitationsState>;

  // required by infinite scroll component
  searchType$ = of(SearchType.gatewayInvitations);
  statusFilters: { value: string; name: string }[];
  initialFilter = '';
  status: InvitationStatusType;

  // loading indicator trigger
  nextBatch = false;

  // page size
  limit = 20;

  // list item height - required by infinite scroll
  itemSize = 50;

  constructor(
    private gatewayInvitationsService: GatewayInvitationsService,
    private gtmService: GTMService
  ) {
    this.statusFilters = this.gatewayInvitationsService.statusFilters;
  }

  ngOnInit(): void {
    this.gatewayInvitationsService.listGatewayInvitations({
      installationId: this.installationId,
      customerNumber: this.customerNumber,
      status: null,
      limit: this.limit,
      offset: 0,
    });
    this.invitations$ = this.gatewayInvitationsService.selectInvitations();
  }

  ngOnDestroy(): void {
    this.gatewayInvitationsService.clearStore();
  }

  onFilterChange(status: InvitationStatusType): void {
    this.status = status;

    this.gatewayInvitationsService.filterByStatus({
      installationId: this.installationId,
      customerNumber: this.customerNumber,
      limit: this.limit,
      offset: 0,
      status,
    });
    this.gtmService.track('onSelect', `${status} invitation status filter`, 'Invitation list');
  }

  onNextBatchChange($event: any): void {
    this.nextBatch = $event;
  }

  onFetchNext({ limit, offset }: { limit: number; offset?: number; cursor?: string }): void {
    this.gatewayInvitationsService.listGatewayInvitations({
      installationId: this.installationId,
      customerNumber: this.customerNumber,
      status: this.status,
      limit,
      offset,
    });
  }

  isScrollbarVisible(): boolean {
    return this.viewport?.['_totalContentSize'] > this.viewport?.['_viewportSize'];
  }
}
